import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

// Deprecated, query id should be tracked outside of the searches duck
export const selectCurrentQueryId = createBasicSelector(
  selectBase,
  base => base.currentQueryId
)
